import { Container, H3, P1, P3, H5 } from '@moneymade/moneymade-ui'
import PropTypes from 'prop-types'

import Highlights from 'modules/discover/PlatformPageNew/HowItWorks/Highlights/Highlights'
import styles from './HowItWorks.module.scss'

const HowItWorks = ({ urlSlug, currentInvestment, verificationStatus, title, description, infoList }) => (
  <div className={styles.HowItWorks}>
    <Container width={1230} className={styles.Content}>
      <H3 className={styles.Header} weight="semibold" id={urlSlug}>
        {title}
      </H3>

      <P1 className={styles.DescTop} weight="light">
        {description}
      </P1>

      <div className={styles.Table}>
        <div className={styles.Left}>
          <P1 className={styles.DescLeft} weight="light">
            {description}
          </P1>

          <div className={styles.InfoCards}>
            {infoList?.map(({ id, name, text }, index) => (
              <div className={styles.Card} key={id}>
                <span className={styles.Circle}>
                  <H5 weight="semibold">{index + 1}</H5>
                </span>

                <div className={styles.List}>
                  <P1 weight="normal">{name}</P1>
                  <P3 weight="light" className={styles.Desc}>
                    {text}
                  </P3>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.Right}>
          {verificationStatus === 'Verified Paying (Premium)' && (
            <Highlights investment={currentInvestment} />
          )}
        </div>
      </div>
    </Container>
  </div>
)

HowItWorks.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  urlSlug: PropTypes.string,
  verificationStatus: PropTypes.string,
  currentInvestment: PropTypes.shape({}),
  infoList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      text: PropTypes.string,
      media: PropTypes.arrayOf(PropTypes.string)
    })
  )
}

HowItWorks.defaultProps = {
  title: '',
  description: '',
  urlSlug: '',
  verificationStatus: '',
  currentInvestment: {},
  infoList: []
}

export default HowItWorks
